import { dmApi } from "../../../app/dmApi";
import { serialize } from "../../../helpers/Utils";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../../helpers/RtkQueryUtils";

export const employeesApi = dmApi.injectEndpoints({
    endpoints: (build) => ({
        searchEmployees: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/employee?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['employees'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        createEmployee: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/employee/create`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['employees'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Employee")
            },
        }),
        getEmployeeById: build.query({
            query: (id) => {
                return {
                    url: `/employee/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['employeeById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        updateEmployee: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/employee/update/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['employees', 'employeeById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Employee")
            },
        }),
        removeEmployee: build.mutation({
            query: (id) => {
                return {
                    url: `/employee/delete/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Removed", "Employee")
            },
            invalidatesTags: ['employees']
        }),
    }),
});


export const {
    useCreateEmployeeMutation,
    useSearchEmployeesQuery,
    useUpdateEmployeeMutation,
    useRemoveEmployeeMutation
} = employeesApi;